import React from 'react';
import clsx from 'clsx';
import { ReactComponent as CameraFlipIcon } from 'assets/images/camera-flip.svg';
import styles from './index.module.scss';

export interface RotateMobileMessageProps {
  className?: string;
}

function RotateMobileMessage(props: RotateMobileMessageProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.content}>
        <div className={styles.device}>
          <CameraFlipIcon />
        </div>
        <span> Please rotate your phone to get started. </span>
      </div>
    </div>
  );
}

export default RotateMobileMessage;
